module.exports = __webpack_public_path__ + "static/ebook-card-image.946ff286.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ebook-card-image.png
// module id = 659
// module chunks = 198182681891205